import styled from "styled-components";
import { theme } from "@themes";

export const FileUploadContainer = styled.section`
  position: relative;
  margin: 25px 0 15px;
  width: 100%;
  height: 140px;
  border: ${(props) =>
    props.greyUI
      ? "1px dashed " + theme.neutral.gray[1800]
      : props.loaded
      ? "2px dotted " + theme.primary.green
      : "2px dotted " + theme.primary.purpleOpacity};
  padding: 7px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .link-label {
    color: ${({ theme }) => theme.primary.purple} !important;
    text-decoration: underline;
    cursor: po;
  }

  .greyUI p {
    margin-top: 10px;
    margin-bottom: 0;
  }

  svg {
    font-size: 4em;
    color: ${({ theme }) => theme.neutral.gray[2600]};
  }
`;

export const FormField = styled.input`
  font-size: 18px;
  display: block;
  width: 100%;
  border: none;
  text-transform: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;

  &:focus {
    outline: none;
  }
`;

export const InputLabel = styled.label`
  top: -21px;
  font-size: 13px;
  color: ${({ theme }) => theme.neutral.black};
  left: 0;
  position: absolute;
`;

export const DragDropText = styled.p`
  font-weight: bold;
  margin-top: 0;
  text-align: center;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-wrap;
  width: auto;
`;

export const UploadFileBtn = styled.button`
  box-sizing: border-box;
  appearance: none;
  background-color: transparent;
  border: 2px solid ${({ theme }) => theme.status.infoLight};
  cursor: pointer;
  font-size: 1rem;
  line-height: 1;
  padding: 1.1em 2.8em;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  border-radius: 6px;
  color: ${({ theme }) => theme.status.infoLight};
  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: color 250ms ease-in-out;
  font-family: ${({ theme }) => theme.font.primary}, sans-serif;
  width: 45%;
  display: flex;
  align-items: center;
  padding-right: 0;
  justify-content: center;

  &:after {
    content: "";
    position: absolute;
    display: block;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 100%;
    background: ${({ theme }) => theme.status.infoLight};
    z-index: -1;
    transition: width 250ms ease-in-out;
  }

  i {
    font-size: 22px;
    margin-right: 5px;
    border-right: 2px solid;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 20%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  @media only screen and (max-width: 500px) {
    width: 70%;
  }

  @media only screen and (max-width: 350px) {
    width: 100%;
  }

  &:hover {
    color: ${({ theme }) => theme.neutral.white};
    outline: 0;
    background: transparent;

    &:after {
      width: 110%;
    }
  }

  &:focus {
    outline: 0;
    background: transparent;
  }

  &:disabled {
    opacity: 0.4;
    filter: grayscale(100%);
    pointer-events: none;
  }
`;

export const FilePreviewContainer = styled.article`
  margin-bottom: 35px;

  span {
    font-size: 14px;
  }
`;

export const PreviewList = styled.section`
  position: relative;
  margin: 25px 0 15px;
  width: 370px;
  height: 140px;
  border: 2px dotted ${({ theme }) => theme.primary.green};
  padding: 7px;
  border-radius: 6px;
  top: -165px;

  @media only screen and (max-width: 400px) {
    flex-direction: column;
  }
`;

export const FileMetaData = styled.div`
  display: ${(props) => (props.isImageFile ? "none" : "flex")};
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px;
  border-radius: 6px;
  color: ${({ theme }) => theme.neutral.white};
  font-weight: bold;
  background-color: rgba(5, 5, 5, 0.55);

  aside {
    margin-top: auto;
    display: flex;
    justify-content: space-between;
  }
`;

export const RemoveFileIcon = styled.i`
  cursor: pointer;

  &:hover {
    transform: scale(1.3);
  }
`;

export const PreviewContainer = styled.section`
  width: ${({ maxWidth }) => maxWidth || "20em"};
  height: 140px;
  border-radius: 6px;
  position: relative;
  box-sizing: border-box;
  top: 20px;

  &:hover {
    ${FileMetaData} {
      display: flex;
    }
  }

  & > div:first-of-type {
    height: 100%;
    position: relative;
  }

  @media only screen and (max-width: 750px) {
    width: 100%;
  }

  @media only screen and (max-width: 500px) {
    width: 100%;
  }

  @media only screen and (max-width: 400px) {
    width: 100%;
    padding: 0 0 0.4em;
  }
`;

export const ImagePreview = styled.img`
  border-radius: 6px;
  width: 100%;
  height: 100%;
`;

export const ContentDragAndDrop = styled.div`
  background-color: ${(props) =>
    props.greyUI
      ? theme.neutral.gray[200]
      : props.loaded
      ? "rgb(51 207 141 / 21%);"
      : "rgb(195 0 145 / 5%)"};
  width: 100%;
  height: 122px;
  text-align: center;
  padding: 1em;
`;
export const NameFileUpload = styled.div`
  background: ${({ theme }) => theme.neutral.gray[1900]};
  color: ${({ theme }) => theme.neutral.white};
  display: flex;
  width: 370px;
  font-size: 14px;
  font-weight: 700;
  border-radius: 9px;
  height: 3em;
  align-items: center;
  justify-content: center;
  margin-bottom: 2em;
`;
